import moment from 'moment'
import 'moment/locale/ko'
import { CHART_DATE_FORMAT, CHART_UNIT } from './chartConstants'
import { isNullOrUndefined, round } from 'utils'
import { MetricColumns } from '../../../Columns'

export const diffDays = (from, to) => moment(to).diff(from, 'days')
export const getChartUnit = (from, to) => {
  const days = diffDays(from, to)
  return days === 0 && moment().diff(moment(from), 'days') <= 89
    ? CHART_UNIT.HOUR
    : CHART_UNIT.DAY
}
export const generateKeys = (from, to) => {
  if (CHART_UNIT.HOUR === getChartUnit(from, to)) {
    const dateId = moment(from).format(CHART_DATE_FORMAT)
    return [...Array(24)].reduce((acc, value, index) => {
      acc.push({
        dateId,
        hour: index,
      })
      return acc
    }, [])
  } else {
    const days = diffDays(from, to)
    return [...Array(days + 1)].reduce((acc, value, index) => {
      const dateId = moment(from).add(index, 'days').format(CHART_DATE_FORMAT)
      acc.push({ dateId })
      return acc
    }, [])
  }
}

export const zeroMetrics = Object.keys(MetricColumns).reduce((acc, value) => {
  acc[value] = 0
  return acc
}, {})

export const zeroFill = (keys, reports) =>
  keys.map(
    ({ dateId, hour }) =>
      reports.find(item =>
        isNullOrUndefined(hour) ? item.dateId === dateId : item.hour === hour
      ) || {
        dateId,
        ...(!isNullOrUndefined(hour) && { hour }),
        ...zeroMetrics,
      }
  )

const tenThousand = 1_0000
const hundredMil = 1_0000_0000
export const getSummaryText = value => {
  const numberValue = Number(value)
  if (isNaN(numberValue)) return value
  const quotient =
    numberValue >= hundredMil
      ? round(numberValue / hundredMil, 2)
      : numberValue >= tenThousand
      ? round(numberValue / tenThousand, 2)
      : numberValue
  const unit =
    numberValue >= hundredMil ? '억' : numberValue >= tenThousand ? '만' : ''
  return quotient.toLocaleString() + unit
}
